import { gql } from '@apollo/client';
import Fragments from './fragments';

export const APPROVAL_TYPE_QUERY = gql`
  query approvalTypeItem($approvalTypeId: Int!, $siteId: Int!) {
    approvalTypeItem(approvalTypeId: $approvalTypeId, siteId: $siteId) {
      ...approvalTypeItem
      approvalTypeLevels {
        ...approvalTypeLevelItem
        approvalTypeEmployees {
          ...approvalTypeEmployeeItem
        }
        approvalTypeUserGroups {
          ...approvalTypeUserGroupItem
        }
      }
      approvalTypeDecisionReasons {
        ...approvalTypeDecisionReasonItem
      }
    }
  }
  ${Fragments.approvalTypeItem}
  ${Fragments.approvalTypeLevelItem}
  ${Fragments.approvalTypeDecisionReasonItem}
  ${Fragments.approvalTypeEmployeeItem}
  ${Fragments.approvalTypeUserGroupItem}
`;

export const DECISION_BEHAVIORS_QUERY = gql`
  query decisionBehaviors($siteId: Int!) {
    decisionBehaviors(siteId: $siteId) {
      decisionBehaviorId
      decisionBehaviorCode
      decisionBehaviorName
    }
  }
`;
